//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import mixin from './mixin.js';
import { articleMenu } from '~/utils/article';

export default {
  name: 'ArticleCarousel',
  mixins: [mixin],
  props: { carouselItem: { type: Array, default: () => [] } },
  data() {
    return {
      articleMenu,
    };
  },
  computed: {
    fullItems() {
      const items = this.carouselItem;
      const length = items.length;

      // 項目長度等於1時不輪播, 大於1小於4時複製一份(大於3)輪播
      if (length > 1 || length < 4) {
        return items.concat(items);
      }

      return items;
    },
  },
  filters: {
    previewContent(content) {
      if (content === null || content === undefined) return '';

      if (content.length > 70) {
        return content + '...';
      }

      return content;
    },
  },
  methods: {
    itemStatus5(index, activeIndex) {
      const length = this.fullItems.length;
      switch (activeIndex) {
        case index:
          return 'on';

        case index + 1:
        case index + 1 - length:
          return 'last';

        case index - 1:
        case index - 1 + length:
          return 'next';

        case index + 2:
        case index + 2 - length:
          return 'beforeLast';

        case index - 2:
        case index - 2 + length:
          return 'afterNext';

        default:
          return 'hide';
      }
    },
    clickItem(category, id) {
      this.$emit('click', category, id);
    },
  },
};
